import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';
import React, { Component } from 'react';
import qs from 'query-string';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import Detail from './components/Detail';
import { growlErrors, growlActionSuccess } from '../../../../utils/NotificationUtil';
import { updateAssessmentTempMutate } from '../../../../services/apps/AssessmentTempServices';
import { buildEmailTemplatesData } from '../../../../utils/TemplateUtil';
import { withAccount } from '../../../../components/AccountContext';
import { withGrowl } from '../../../../components/GrowlNotifications';
import { Loading } from '../../../../components/Loading';
import {
  locationShape, intlShape, matchShape, growlShape,
} from '../../../../components/prop-types';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
});

const mapStateToProps = (state) => {
  const { translatedTags } = state.i18n;
  return {
    translatedTags,
  };
};

class DetailContainer extends Component {
  constructor(props) {
    super(props);
    const { location } = props;
    const query = qs.parse(location.search);
    this.state = {
      editing: (query && query.edit) ? query.edit : false,
    };
    this.submitEditData = this.submitEditData.bind(this);
    this.closeEditing = this.closeEditing.bind(this);
    this.editTemplate = this.editTemplate.bind(this);
  }

  async submitEditData(formValues) {
    const {
      currentAccount, intl,
      match, growl,
    } = this.props;
    const { formatMessage } = intl;
    const { title } = formValues;
    const {
      feedbackTemplateId, inviteTemplateId, reminderTemplateId, thankYouTemplateId,
    } = buildEmailTemplatesData(
      formValues,
    );
    const AssessmentTempValues = {
      accountId: currentAccount,
      assessmentTemplateId: match.params.templateId,
      title,
      feedbackTemplateId,
      inviteTemplateId,
      reminderTemplateId,
      thankYouTemplateId,
    };
    try {
      await updateAssessmentTempMutate(AssessmentTempValues);
      this.setState({ editing: false });
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  editTemplate() {
    this.setState({ editing: true });
  }

  closeEditing() {
    this.setState({ editing: false });
  }

  render() {
    const {
      translatedTags,
      match,
      data,
    } = this.props;
    const { editing } = this.state;
    const { templateId } = match.params;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="brand-detailed-wrapper">
            <Detail
              languageList={translatedTags}
              templateId={templateId}
              submitEditData={this.submitEditData}
              editTemplate={this.editTemplate}
              closeEditing={this.closeEditing}
              editing={editing}
              data={data}
            />
          </div>
        </div>
      </div>
    );
  }
}

DetailContainer.propTypes = {
  location: locationShape.isRequired,
  currentAccount: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
  match: matchShape.isRequired,
  growl: growlShape.isRequired,
  translatedTags: PropTypes.arrayOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

const AMST_QUERY = gql`query($accountId: ID!, $id: ID!, $first: Int) {
  account(id: $accountId) {
    id
    assessmentTemplate(id: $id) {
      inviteTemplateId
      thankYouTemplateId
      feedbackTemplateId
      reminderTemplateId
      id
      title
      createdOn
      updatedOn
      activeLocales
      cognitiveDimensions
      behaviorDimensions
      interestsDimensions
      reportActiveLocales
      jpsActiveLocales
      createdBy {
        id
        email
        firstName
        lastName
      }
    }
    communicationTemplates(first: $first) {
      edges {
        node {
          id
          name
          type
        }
      }
    }
    assessmentSections {
      behaviorSection {
        displayName
        dimensions {
          name
          displayName
        }
      }
      cognitiveSection {
        displayName
        dimensions {
          name
          displayName
        }
      }
      interestsSection {
        displayName
        dimensions {
          name
          displayName
        }
      }
    }
  }
}`;

const DetailQuery = ({ currentAccount, match, ...rest }) => (
  <Query
    query={AMST_QUERY}
    variables={{
      id: match.params.templateId,
      accountId: currentAccount,
      first: 200,
    }}
  >
    {({ loading, error, data }) => {
      if (loading) return <Loading />;
      if (error) return `Error! ${error.message}`;

      return (
        <DetailContainer
          {...rest}
          match={match}
          currentAccount={currentAccount}
          data={data}
        />
      );
    }}
  </Query>
);

DetailQuery.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  match: matchShape.isRequired,
};

const assessmentTempGraphql = withRouter(withGrowl(DetailQuery));

export default withAccount(
  connect(
    mapStateToProps,
  )(injectIntl(assessmentTempGraphql)),
);
